import {
  Button,
  Dialog,
  FormControl,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { colorPrimary, colorTextBlack } from '../../../config/theme';
import { addNewTag } from '../../../redux/reducers/contentSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const AddNewTagModal = ({ open, handleClose }) => {
  const [newTag, setNewTag] = useState('');
  const dispatch = useDispatch();
  const { authData } = useSelector(state => state.auth);

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '8px'
        }
      }}
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Grid sx={{ padding: '24px' }}>
        <Typography
          fontSize={'20px'}
          color={colorTextBlack}
          fontWeight={'700'}
          mb={2}
        >
          Add new tag
        </Typography>
        <FormControl variant="outlined" fullWidth size="small" sx={{ mb: 2 }}>
          <TextField
            name="newTag"
            placeholder="Add new tag"
            variant="outlined"
            size="small"
            sx={{ width: '440px' }}
            value={newTag}
            onChange={e => setNewTag(e.target.value)}
          />
        </FormControl>
        <Grid mt={2} item display={'flex'} justifyContent={'start'} gap={2}>
          <Button
            variant="outlined"
            onClick={() => handleClose()}
            sx={{
              px: 4,
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: 'black',
              borderWidth: '2px',
              height: '42px',
              width: '106px',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={newTag === ''}
            sx={{ mr: 2, px: 4, borderWidth: 2, width: '90px' }}
            onClick={() => {
              const payload = {
                contentTag: newTag,
                loggedInUserName: authData?.userName
              };
              dispatch(addNewTag(payload));
              handleClose();
              setNewTag('');
            }}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default AddNewTagModal;
